export enum BundleType {
    travelComponents = 'travelComponents',
    journey = 'journey'
}